export default class Queue {
	_items;
	_activeItems;
	_processItems;
	_maxConcurrency;
	_processor;
	
	constructor ({ processor, autoStart = true, maxConcurrency = 2 }) {
		this._items = [];
		this._activeItems = [];
		this._processItems = autoStart;
		this._maxConcurrency = maxConcurrency;
		this._processor = processor;
	}
	get maxConcurrency () {
		return this._maxConcurrency;
	}
	set maxConcurrency (val) {
		this._maxConcurrency = val;
	}
	enqueueAfter (data, delayMs = 0) {
		setTimeout(() => {
			this.enqueue(data);
		}, Math.max(delayMs || 0, 0));
	}
	enqueue (data) {
		this._items.push(data);
		this._process();
	}
	start () {
		this._processItems = true;
		this._process();
	}
	stop () {
		this._processItems = false;
	}
	_process () {
		while (this._processItems && this._items.length > 0 && this._activeItems.length < this._maxConcurrency) {
			const item = this._items.shift();
			this._activeItems.push(item);
			this._processor(item)
				.finally(() => {
					const idx = this._activeItems.indexOf(item);
					this._activeItems.splice(idx, 1);
					this._process();
				});
		}
	}
}